import { ref } from "vue";
import { fabric } from "fabric";

import { addUserObject, getObjectProperty } from "@/canvas-api/Canvas";

export const clipArt = ref<fabric.Object | fabric.Group>();
export const makeNewClipArt = (result: string): void => {
  fabric.loadSVGFromString(result, function(objects, options) {
    const loadedObjects: fabric.Object[] = objects;

    loadedObjects.forEach((obj) => {
      obj.set({
        strokeWidth: 0,
        stroke: "#0001ba",
        fill: "#000",
      });
    });

    const clipGroup = fabric.util.groupSVGElements(loadedObjects, options) as fabric.Object;

    clipGroup.set({
      opacity: 1,
      stroke: "#0001ba",
      originX: "center",
      originY: "center",
      name: "clipArt",
    });

    addUserObject(clipGroup);
  });
};

export const updateClipArt = (prop: string, value: string | boolean | number) => {
  getObjectProperty({ name: prop, value: value, });
};
